import Vue from "vue";
import { Toast } from "vant";
import i18n from "../lang";
// let dialogInstance = null

// TOTEST 需测试是否兼容移动端浏览器
export const clipboard = {
  async copy(text) {
    // 新浏览器使用API
    if (navigator.clipboard) {
      try {
        return await navigator.clipboard.writeText(text);
      } catch (err) {
        console.error("Async clipboard copy failed:", err);
        return await this.legacyCopy(text);
      }
    }
    return this.legacyCopy(text);
  },

  legacyCopy(text) {
    return new Promise((resolve, reject) => {
      // 创建临时textarea
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";

      document.body.appendChild(textarea);
      textarea.select();

      try {
        // 兼容老版本iOS
        const success = document.execCommand("copy");
        document.body.removeChild(textarea);
        success ? resolve() : reject(new Error("Copy failed"));
      } catch (err) {
        document.body.removeChild(textarea);
        reject(err);
      }
    });
  },
  async paste() {
    // 新浏览器使用API
    if (navigator.clipboard) {
      try {
        return await navigator.clipboard.readText();
      } catch (err) {
        console.error("Async clipboard read failed:", err);
        return this.legacyPaste();
      }
    }
    return this.legacyPaste();
  },

  legacyPaste() {
    return new Promise((resolve) => {
      console.log("开始传统粘贴方法");
      const input = document.createElement("input");
      input.style.cssText = `
			position: fixed;
			top: 10%;
			left: 50%;
			transform: translateX(-50%);
			width: 200px;
			height: 20px;
			opacity: 0.01;
			z-index: 9999;
		  `;

      input.addEventListener(
        "paste",
        (e) => {
          console.log("捕获到粘贴事件", e.clipboardData.types);
          const content = e.clipboardData.getData("text/plain");
          console.log("获取到的文本内容:", content);
          resolve(content);
          document.body.removeChild(input);
        },
        { once: true }
      );

      document.body.appendChild(input);
      input.focus();
      console.log("输入框已聚焦");

      setTimeout(() => {
        if (document.body.contains(input)) {
          console.warn("粘贴超时");
          resolve(null);
          document.body.removeChild(input);
        }
      }, 1000);
    });
  },
};

export const langList = {
  GDT: [
    { title: "简体中文", label: "简体中文", value: "zh_CN" },
    { title: "繁體中文", label: "繁体中文", value: "zh_TW" },
    { title: "English", label: "英语", value: "en" },
    { title: "한국어", label: "한국어", value: "ko" },
    { title: "日本語", label: "日本語", value: "ja" },
  ],
};

// 处理后端返回i18n数据
export function processI18nKeys(obj, i18nMessage) {
  // 处理数组情况
  if (Array.isArray(obj)) {
    return obj.map((item) => processI18nKeys(item, i18nMessage));
  }

  // 处理对象情况
  if (typeof obj === "object" && obj !== null) {
    const result = {};
    const langPrefix = i18nMessage ? `${i18nMessage.toLowerCase()}_` : "";

    for (const key in obj) {
      if (key.startsWith(langPrefix)) {
        const newKey = key.replace(langPrefix, "");
        result[newKey] = processI18nKeys(obj[key], i18nMessage);
      } else if (key === i18nMessage) {
        result["data"] = processI18nKeys(obj[key], i18nMessage);
      } else {
        result[key] = processI18nKeys(obj[key], i18nMessage);
      }
    }

    return result;
  }

  // 基本类型直接返回
  return obj;
}
export const updateTranslatedList = (oldarray) => {
  console.log(oldarray);

  return oldarray.map((item) => ({
    ...item,
    text: i18n.t(item.text),
  }));
};
// 弹窗初始化
// export function initDialog() {
// 	const DialogComponent = Vue.extend(require('@/components/comConfirmDialog').default)
// 	dialogInstance = new DialogComponent().$mount()
// 	document.body.appendChild(dialogInstance.$el)
// }
// 弹窗调用

// export function componentmethod(options) {
// 	console.log(options);
// 	let dialogInstance = null;
// 	if (dialogInstance) {
//         dialogInstance.$destroy();
//         document.body.removeChild(dialogInstance.$el); // 移除 DOM
//     }
// 	const DialogComponent = Vue.extend(options.component); // 直接使用传入的组件对象
// 	dialogInstance = new DialogComponent().$mount();
// 	document.body.appendChild(dialogInstance.$el);
// 	return dialogInstance.open(options);
//   }

// 对话框初始化
export function confirmDialog(options) {
  // if (!dialogInstance) {
  // 	initDialog()
  // }
  const DialogComponent = Vue.extend(
    require("@/components/comConfirmDialog").default
  );
  let dialogInstance = new DialogComponent().$mount();
  document.body.appendChild(dialogInstance.$el);
  return dialogInstance.open(options);
}

// 邀请链接弹窗初始化
export function invitationDialog(options) {
  // if (!dialogInstance) {
  // 	initDialog()
  // }
  const DialogComponent = Vue.extend(
    require("@/components/comInvitationDialog").default
  );
  let dialogInstance = new DialogComponent().$mount();
  document.body.appendChild(dialogInstance.$el);
  return dialogInstance.open(options);
}

export const scrollListener = {
  handlers: [],

  // 添加滚动监听
  addListener(handler) {
    this.handlers.push(handler);
    if (this.handlers.length === 1) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },

  // 移除滚动监听
  removeListener(handler) {
    this.handlers = this.handlers.filter((h) => h !== handler);
    if (this.handlers.length === 0) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },

  // 处理滚动事件
  handleScroll() {
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;
    this.handlers.forEach((handler) => {
      handler({ scrollY, scrollX });
    });
  },
};

// 倒计时方法  格式：天时分秒，时分秒，分秒 callback接受返回的字符串
export function startCountdown(
  startTimestamp,
  endTimestamp,
  format = "d:h:m:s",
  callback
) {
  // 计算初始时间差
  let diff = endTimestamp - startTimestamp;

  const update = () => {
    callback(formatTime(diff, format));
  };

  const formatTime = (timeDiff, fmt) => {
    if (timeDiff <= 0) {
      return fmt === "d:h:m:s"
        ? ["0", "00", "00", "00"]
        : fmt === "h:m:s"
        ? ["00", "00", "00"]
        : ["00", "00"];
    }

    const seconds = Math.floor(timeDiff / 1000) % 60;
    const minutes = Math.floor(timeDiff / (1000 * 60)) % 60;
    const hours = Math.floor(timeDiff / (1000 * 60 * 60)) % 24;
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    const pad = (num) => num.toString().padStart(2, "0");

    switch (fmt) {
      case "d:h:m:s":
        return [days, pad(hours), pad(minutes), pad(seconds)];
        return `${days}天${pad(hours)}时${pad(minutes)}分${pad(seconds)}秒`;
      case "h:m:s":
        return [pad(hours), pad(minutes), pad(seconds)];
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      case "m:s":
        return [pad(minutes), pad(seconds)];
        return `${pad(hours)}:${pad(minutes)}`;
      default:
        return [days, pad(hours), pad(minutes), pad(seconds)];
        return `${days}天${pad(hours)}时${pad(minutes)}分${pad(seconds)}秒`;
    }
  };

  const timer = setInterval(() => {
    diff -= 1000;
    update();

    if (diff <= 0) {
      clearInterval(timer);
    }
  }, 1000);

  update();

  // 返回清除方法
  return {
    timer,
    clear: () => {
      clearInterval(timer);
    },
  };
}

// 处理数字为美式格式
export function formatNumberWithCommas(num) {
  // 转换为字符串并移除可能存在的逗号
  const numStr = String(num).replace(/,/g, "");

  // 检查是否为有效数字
  if (isNaN(numStr)) return num;

  // 分割整数和小数部分
  const parts = numStr.split(".");
  let integerPart = parts[0];
  const decimalPart = parts.length > 1 ? `.${parts[1]}` : "";

  // 添加千分位逗号
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return integerPart + decimalPart;
}

// 确保handleScroll的this指向正确
scrollListener.handleScroll = scrollListener.handleScroll.bind(scrollListener);

// 处理地址
Vue.filter("toolAddr", function (a, lb = 4) {
  if (a) {
    if (a.length > 8) {
      return a.substr(0, lb) + "..." + a.substr(a.length - lb);
    } else {
      return a;
    }
  } else {
    return "--";
  }
});
// 处理小数位
Vue.filter("formatThous", function (num, flag = true, decimalPlaces = 4) {
  if (num === null || num === undefined || num === "" || Number(num) <= 0)
    return "0";
  // 处理科学计数法
  const numStr = num.toString();
  // 分割整数和小数部分
  const [integerPart, decimalPart = ""] = numStr.split(".");
  // 添加千位分隔符（如 "1234567" → "1,234,567"）
  // .toLocaleString()
  let formattedInteger;
  if (flag) {
    formattedInteger = parseInt(integerPart, 10).toLocaleString();
  } else {
    formattedInteger = parseInt(integerPart, 10);
  }
  // 截取指定小数位数
  const truncatedDecimal = decimalPart.slice(0, decimalPlaces);
  // 拼接结果
  return truncatedDecimal
    ? `${formattedInteger}.${truncatedDecimal}`
    : formattedInteger;
});
const scientificToDecimal = (num) => {
  const numStr = num.toString();
  // 检查是否是科学计数法（如 "1.23e+5"）
  if (numStr.includes("e")) {
    const [coefficient, exponent] = numStr.split("e");
    const exp = parseInt(exponent, 10);
    const [integer, decimal = ""] = coefficient.split(".");
    // 处理正指数（如 1.23e+5 → 123000）
    if (exp > 0) {
      const paddedDecimal = (decimal + "0".repeat(exp)).slice(0, exp);
      return integer + paddedDecimal;
    }
    // 处理负指数（如 1.23e-5 → 0.0000123）
    else {
      const leadingZeros = "0".repeat(Math.abs(exp) - 1);
      return `0.${leadingZeros}${integer}${decimal}`;
    }
  }
  return numStr; // 非科学计数法直接返回
};
// / 立即执行的防抖
export const debounceImmediate = (
  func,
  wait,
  immediate = true,
  key = "debounce_lock_key"
) => {
  let timer = null;

  return function (...args) {
    const context = this;
    const now = Date.now();
    // 从 localStorage 获取上次执行时间
    const lastExecTime = parseInt(localStorage.getItem(key), 10) || 0;
    if (now - lastExecTime < wait) {
      Toast("操作频繁,请稍后再试");
      return;
    }
    if (immediate) {
      // 立即执行并记录时间戳
      func.apply(context, args);
      localStorage.setItem(key, now.toString());
    } else {
      // 延迟执行
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
        localStorage.setItem(key, Date.now().toString());
      }, wait);
    }
  };
};
// 时间戳1744013178转年月日或年月日时分秒
// 时间戳1744013178转年月日或年月日时分秒
export function timestampToDate(timestamp, fmt = "yyyy-MM-dd hh:mm:ss") {
  const date = new Date(timestamp * 1000); // 秒转毫秒

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");
  // 根据 fmt 格式替换字符串
  return fmt
    .replace("yyyy", year)
    .replace("MM", month)
    .replace("dd", day)
    .replace("hh", hour)
    .replace("mm", minute)
    .replace("ss", second);
}
